const normalizeComposerAttachmentContextBudget = (value = null) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return null;
  }

  return {
    availableContextTokens: Math.max(0, Number(value?.availableContextTokens || 0)),
    estimatedRequiredTokens: Math.max(0, Number(value?.estimatedRequiredTokens || 0)),
    isAtRisk: value?.isAtRisk === true,
    status:
      String(value?.status || '')
        .trim()
        .toLowerCase() || 'safe',
    totalContextTokens: Math.max(0, Number(value?.totalContextTokens || 0)),
    usagePercent: Math.max(0, Number(value?.usagePercent || 0)),
    usedContextTokens: Math.max(0, Number(value?.usedContextTokens || 0))
  };
};

export default normalizeComposerAttachmentContextBudget;
